<template>
    <v-card width="100%" class="mt-3 pt-3 pl-3 pr-3" color="#eee">
        <v-row>
            <v-col cols="12">
                <h3>{{index}}. {{question.title}}</h3>
            </v-col>
            <v-col cols="12" class="pl-3">
                <v-radio-group v-model="selfChoice" :disabled="true">
                    <v-radio v-for="(n, idx) in question.choice" :key="idx" :label="n.title" :value="n.id"></v-radio>
                    <v-radio :label="question.description" value="textresponse"></v-radio><v-text-field class="input_700 ml-3" label="回答區域" value="" :disabled="true" v-model="textans"></v-text-field>
                </v-radio-group>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    props:{
        index: {
            type: Number,
            default: -1,
        },
        question: {
            type: Object,
            default: {
                id: -1,
                title: "",
                choice: []
            }
        },
        choice: {
            type: [Number, String],
            default: -1
        }
    },
    data(){
        return {
            textans: "",
            selfChoice: this.choice,
        }
    },
    watch:{
        choice(val){
          if (isNaN(val)) {
            this.selfChoice = "textresponse";
            this.textans = val;
          }
          else{
            this.selfChoice = val;
          }
        }
    },
}
</script>
